import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-[50px] m-3 fixed top-0 left-0",
  src: _imports_0
}, null, -1)
const _hoisted_2 = { class: "flex h-screen overflow-hidden app-bg-img" }
const _hoisted_3 = { class: "m-auto z-10 w-full px-2 sm:px-0 sm:w-auto text-center" }
const _hoisted_4 = { class: "titleFont text-xl md:text-3xl" }
const _hoisted_5 = {
  key: 0,
  class: "max-w-md mx-auto"
}
const _hoisted_6 = { class: "titleFont text-2xl md:text-4xl my-5 text-primary-300 dark:text-primary-400" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 4,
  class: "my-3"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "titleFont text-2xl md:text-4xl my-5 text-primary-300 dark:text-primary-400" }, "Just a moment ⭐", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "mt-5" }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Separator = _resolveComponent("Separator")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Interests = _resolveComponent("Interests")!
  const _component_ButtonArrowLeftIcon = _resolveComponent("ButtonArrowLeftIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonArrowRightIcon = _resolveComponent("ButtonArrowRightIcon")!
  const _component_SpinnerIcon = _resolveComponent("SpinnerIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('Hi! Set up your profile to continue')) + " 😄", 1),
        _createVNode(_component_Separator),
        (!_ctx.processing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.currentSelection.title), 1),
              (_ctx.currentSelection.type == 'input-text')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "text",
                    placeholder: _ctx.currentSelection.data,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.models[_ctx.currentSelectionName]) = $event)),
                    class: "transition-colors duration-150 block w-full px-4 py-3 text-sm rounded-lg border-2 text-gray-600 bg-gray-100 border-gray-100 hover:bg-gray-200 hover:border-gray-200 focus:bg-gray-200 focus:border-gray-200 dark:text-gray-200 dark:bg-gray-800 dark:border-gray-800 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:bg-gray-700 dark:focus:border-gray-700 md:text-xl mt-3 titleFont"
                  }, null, 8, _hoisted_7)), [
                    [
                      _vModelText,
                      _ctx.models[_ctx.currentSelectionName],
                      void 0,
                      { lazy: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (_ctx.currentSelection.type == 'input-date')
                ? (_openBlock(), _createBlock(_component_DatePicker, {
                    key: 1,
                    value: _ctx.models[_ctx.currentSelectionName],
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.models[_ctx.currentSelectionName]) = $event)),
                    class: "text-black"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.currentSelection.type == 'simple-list')
                ? (_openBlock(), _createBlock(_component_Select, {
                    key: 2,
                    modelValue: _ctx.models[_ctx.currentSelectionName],
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.models[_ctx.currentSelectionName]) = $event)),
                    options: _ctx.currentSelection.data,
                    sel: _ctx.models[_ctx.currentSelectionName]
                  }, null, 8, ["modelValue", "options", "sel"]))
                : _createCommentVNode("", true),
              (_ctx.currentSelection.type == 'tagged-array&emoji')
                ? (_openBlock(), _createBlock(_component_Interests, {
                    key: 3,
                    onSelected: _cache[3] || (_cache[3] = _ => {_ctx.models[_ctx.currentSelectionName] = _}),
                    selects: _ctx.models[_ctx.currentSelectionName],
                    min: _ctx.currentSelection.min,
                    max: _ctx.currentSelection.max,
                    dataset: _ctx.currentSelection.data
                  }, null, 8, ["selects", "min", "max", "dataset"]))
                : _createCommentVNode("", true),
              (Object.keys(_ctx.errors).includes(_ctx.currentSelectionName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors[_ctx.currentSelectionName], (e) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "text-red-400",
                          key: e
                        }, _toDisplayString(e), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.swipe(false))),
            disabled: !_ctx.hasPrev || _ctx.processing
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonArrowLeftIcon),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Back')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_ctx.hasNext)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.swipe(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Next')) + " ", 1),
                  _createVNode(_component_ButtonArrowRightIcon)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _ctx.submit,
                class: "!border-primary-300",
                disabled: _ctx.processing
              }, {
                default: _withCtx(() => [
                  (!_ctx.processing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('Submit')), 1))
                    : (_openBlock(), _createBlock(_component_SpinnerIcon, { key: 1 }))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
        ])
      ])
    ])
  ], 64))
}